import React, { Component } from 'react';
import Dropdown from './Dropdown';
import DropdownOption from './DropdownOption'
import { EditorState, Modifier } from 'draft-js';

class MailMergeDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        }
        this.doExpand = this.doExpand.bind(this);
        this.doCollapse = this.doCollapse.bind(this);
        this.onExpandEvent = this.onExpandEvent.bind(this);
        this.onSelected = this.onSelected.bind(this);
    }
    
    doExpand() {
        this.setState({
          expanded: true,
        });
      };
    
      doCollapse() {
        this.setState({
          expanded: false,
        });
      };

    onExpandEvent() {
        const {expanded} = this.state;
        this.setState({
            expanded: !expanded
        })
    }
    onSelected(value) {

        const {editorState, onChange} = this.props;

        const contentState = Modifier.replaceText(
            editorState.getCurrentContent(),
            editorState.getSelection(),
            `{{${value}}}`,
            editorState.getCurrentInlineStyle(),
          );
          onChange(EditorState.push(editorState, contentState, 'insert-characters'));
    }
    render() {
        const {expanded} = this.state;
        const {fields} = this.props;
        return (
                <Dropdown
                onChange={this.onSelected}
                expanded={expanded}
                onExpandEvent={this.onExpandEvent}
                doExpand={this.doExpand}
                doCollapse={this.doCollapse}
                >
                    <span>
                        {'Merge Fields'}
                    </span>
                    {fields ? fields.map((field, index) => 
                    (<DropdownOption
                        value={field}
                        key={index}
                      >
                        {field}
                      </DropdownOption>)) : null}
                </Dropdown>
        );
    }
}

MailMergeDropdown.propTypes = {

};

export default MailMergeDropdown;